import { render } from "./ComparisonTable.vue?vue&type=template&id=15e7ffac"
import script from "./ComparisonTable.vue?vue&type=script&lang=js"
export * from "./ComparisonTable.vue?vue&type=script&lang=js"

import "./ComparisonTable.vue?vue&type=style&index=0&id=15e7ffac&lang=css"

import exportComponent from "/opt/build/repo/lemmi_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__